import { Modal, Paper, Typography, Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import CustomCopyToClipboard from 'components/CustomCopyToClipboard';
import React, { Component } from 'react';

const decorate = withStyles((theme) => ({
  modalBooster: {
    padding: '1.5rem',
    width: '95vw',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    [theme.breakpoints.up('md')]: {
      width: 640,
    },
  },
}));

interface IProps {
  open: boolean;
  productId?: number;
  classes?: any;
  product: any;
  url?: any;
  newUrl?: any;
  onClose: any;
}

class ChekoutBooster extends Component<IProps, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      url: '',
    };
  }

  render() {
    const { classes } = this.props;
    return (
      <Modal open={this.props.open} onClose={this.props.onClose}>
        <Paper className={classes.modalBooster}>
          <Typography variant='h6' style={{ color: '#192542' }}>
            Acelerador de Checkout
          </Typography>
          <div className='m16' />
          Insira o script abaixo em sua página de vendas para que seja feito o pré carregamento do Checkout, dessa forma quando seu cliente clicar em
          comprar e for redirecionado para o checkout, o mesmo irá carregar bem mais rápido, aumentando a possibilidade de conversão.
          <Typography variant='subtitle1' style={{ color: '#818B9D' }}></Typography>
          <div className='m24' />
          <CustomCopyToClipboard
            style={{ width: '100%', fontSize: 11 }}
            text={`<script>(function(d,c) {var i=c||'preload',u,ifw='PGlmcmFtZSB3aWR0aD0iMCIgaGVpZ2h0PSIwIiBzdHlsZT0icG9zaXRpb246IGFic29sdXRlO3RvcDotMTAwMHB4OyIgc3JjPSJodHRwczovL3N1bi5lZHV6ei5jb20vcGl4ZWwve2lkfSI+PC9pZnJhbWU+';d.write(atob(ifw).replace('{id}',i));})(document,${this.props.product.id});</script>`}
            disableUnderline={true}
          ></CustomCopyToClipboard>
          <div className='m16' />
          <div style={{ textAlign: 'right' }}>
            <Button color='default' onClick={this.props.onClose}>
              Fechar
            </Button>
          </div>
        </Paper>
      </Modal>
    );
  }
}

export default decorate(ChekoutBooster);
